import { render, staticRenderFns } from "./Bollettino.vue?vue&type=template&id=ea97e346"
import script from "./Bollettino.vue?vue&type=script&lang=js"
export * from "./Bollettino.vue?vue&type=script&lang=js"
import style0 from "./Bollettino.vue?vue&type=style&index=0&id=ea97e346&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports